import { initPlayer } from "crosstalk-comments-livechat-sdk";
export function autoInitPlayers() {
    const playerDivs = document.querySelectorAll('div[data-crosstalk-video-player]');
    const playerEmbeds = [];
    playerDivs.forEach(playerDiv => {
        const config = {
            wp: playerDiv.dataset.wp,
            url: playerDiv.dataset.url || "",
            pageID: playerDiv.dataset.pageId || "",
            theme: playerDiv.dataset.theme || "light",
            src: playerDiv.dataset.src || "",
            srcType: playerDiv.dataset.srcType || "",
            ytvid: playerDiv.dataset.ytId || "",
            rtvid: playerDiv.dataset.rtId || "",
            vkvid: playerDiv.dataset.vkId || "",
            vklive: playerDiv.dataset.vkLive || "",
            vimeoid: playerDiv.dataset.vimeoId || "",
            height: playerDiv.dataset.height || "",
            locale: playerDiv.dataset.lang || "en"
        };
        const instance = initPlayer(playerDiv, config);
        if (instance)
            playerEmbeds.push(instance);
    });
    return playerEmbeds;
}
